var _defs, _rect, _path, _path2, _rect2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMixteIconeNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.996,
    height: 30,
    viewBox: "0 0 36.996 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35.273,
    height: 3.633,
    transform: "translate(0 26.367)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M113.137,23.56l-1.853-2.812a6.182,6.182,0,0,1,1.1-8.379v-.284a3.267,3.267,0,0,1,.414-1.1,3.458,3.458,0,0,1,2.275-1.708V0H97.185V20.977H94v3.633h19.137ZM102.8,5.156h6.65V6.914H102.8Zm-1.7,3.516h10.049V10.43H101.1Zm8.35,5.273H102.8V12.188h6.65Z",
    transform: "translate(-88.492)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M427.659,221.357v-.247h-8.638v.248a5.375,5.375,0,0,0-.957,7.286l1.92,2.7v1.32H426.7v-1.318l1.921-2.689A5.429,5.429,0,0,0,427.659,221.357Zm-.957,6.473h-6.718v-3.84H426.7Z",
    transform: "translate(-392.62 -208.154)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.801,
    height: 1.92,
    transform: "translate(28.321 16.796)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M459.559,140.642a1.424,1.424,0,0,0,.1-.53,1.441,1.441,0,1,0-2.88,0,1.425,1.425,0,0,0,.1.53,3.926,3.926,0,0,0-2.777,1.87h8.227A3.926,3.926,0,0,0,459.559,140.642Z",
    transform: "translate(-427.502 -130.517)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixteIconeNew);
export default __webpack_public_path__ + "static/media/mixte-icone-new.44ebdb89e1d125e1225b57074238d55a.svg";
export { ForwardRef as ReactComponent };